export const celsiusToFarenheit = (tc: number) => tc * 1.8 + 32
export const farenheitToCelsus = (tf: number) => (tf - 32) * (5 / 9)
export const degreesFarenheit = '\xB0F'
export const degreesCelsius = '\xB0C'
